import { useState, type FormEvent } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { authClient } from "../../lib/auth-client";

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const { error: signInError } = await authClient.signIn.email({ email, password });
    setSubmitting(false);
    if (signInError) {
      setError("E-Mail oder Passwort ist falsch.");
      return;
    }
    const redirectTo = (location.state as { from?: string } | null)?.from ?? "/";
    void navigate(redirectTo, { replace: true });
  }

  return (
    <div className="pw-centered-page">
      <div className="pw-centered-page__panel pw-card">
        <h1 style={{ margin: "0 0 0.3rem", fontSize: "1.4rem", fontWeight: 600, letterSpacing: "-0.02em" }}>Anmelden</h1>
        <p style={{ margin: "0 0 1.2rem", fontSize: "0.85rem", color: "var(--pw-color-text-muted)" }}>
          Parawissen ist eine private Plattform für eingeladene Mitglieder.
        </p>

        {error && (
          <div className="pw-alert pw-alert--error" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={(e) => void onSubmit(e)} noValidate>
          <div className="pw-field">
            <label htmlFor="email">E-Mail</label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="pw-field">
            <label htmlFor="password">Passwort</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="pw-button pw-button--primary" disabled={submitting} style={{ width: "100%" }}>
            {submitting ? "Wird geprüft …" : "Anmelden"}
          </button>
        </form>

        <p style={{ margin: "1rem 0 0", fontSize: "0.8rem", textAlign: "center" }}>
          <Link to="/forgot-password">Passwort vergessen?</Link>
        </p>
      </div>
    </div>
  );
}
